import dayjs from 'dayjs'
import { useCallback, useMemo, useState } from 'react'
import { useGetExpertiseMeetingsQuery } from '@/core/services/expertise-meeting'
import { useAccumulatedData } from '@/hooks/useAccumulatedData'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { useIsUS } from '@/hooks/useIsUS'

const ITEMS_PER_PAGE = 10

export function useExpertiseMeetings() {
  const authUser = useAppSelector(selectAuthUser)
  const [page, setPage] = useState(0)
  const isUS = useIsUS()
 
  const { data: expertiseMeetings } = useGetExpertiseMeetingsQuery({
    establishment: authUser?.establishment?._id,
    limit: ITEMS_PER_PAGE,
    skip: page * ITEMS_PER_PAGE,
  })

  const data = useMemo(
    () =>
      expertiseMeetings?.map((expertiseMeeting) => ({
        id: expertiseMeeting._id,
        name: expertiseMeeting.title,
        patient: expertiseMeeting.patient.userInfo.name + ' ' + expertiseMeeting.patient.userInfo.surname,
        startDate: isUS ? dayjs(expertiseMeeting.timestamp).format('MM/DD/YYYY h:mm A') : dayjs(expertiseMeeting.timestamp).format('DD/MM/YYYY HH:mm'),
      })) ?? [],
    [expertiseMeetings]
  )

  const accumulatedData = useAccumulatedData(data)

  const hasNextPage = useMemo(() => {
    return (expertiseMeetings?.length ?? 0) >= ITEMS_PER_PAGE
  }, [expertiseMeetings])

  const setNextPage = useCallback(() => {
    setPage((prevPage) => prevPage + 1)
  }, [])

  return { data: accumulatedData, hasNextPage, setNextPage }
}
